
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import UnitInput from "@/components/Reusable/CustomInputs/UnitInput/UnitInput.vue";
import { RangeOptions } from "@/types/controls";
import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import { ControlNumber } from "@/oxygen/classes/lib/types";

@Component({
  components: { NumberInput, UnitInput }
})
export default class OxygenUnitInput extends Vue {
  @Prop()
  control!: ControlNumber;

  @ModelSync("value", "input", { type: Number })
  syncedValue?: number;

  get rangeOptions(): RangeOptions {
    return {
      min: this.control.min,
      max: this.control.max,
      step: this.control.step
    };
  }

  get arrows() {
    return this.control.arrows !== false;
  }
}
